module.exports = __webpack_public_path__ + "img/caiwuguanli.031f3de2.svg";